import React, { useLayoutEffect, useRef, useState } from "react";

import { isEllipsisActive } from "utils/utils";

import { DupontTooltip } from "components/DupontTooltip";

const TooltipLabelWithEllipsis = ({ label, customClass, multiline }) => {
  const labelRef = useRef(null);
  const [labelWithEllipse, setLabelWithEllipse] = useState(false);
  let labelClass = customClass || "calculatedValueText";
  labelClass += multiline ? "" : ` overflow`;

  useLayoutEffect(() => {
    setLabelWithEllipse(multiline || isEllipsisActive(labelRef));
  }, [labelRef?.current?.scrollWidth]);

  return (
    <DupontTooltip title={label} placement="bottom-start" type={labelWithEllipse ? "primary" : "none"}>
      <span className={labelClass} ref={labelRef}>
        {label}
      </span>
    </DupontTooltip>
  );
};

export default TooltipLabelWithEllipsis;
